module.exports = __webpack_public_path__ + "img/appAsset--suppliers-groups-ax.5b5de24c.svg";